const featureES = {
    "view": {
        "table": {
            "title": "Solicitudes de Funciones",
            "column": {
                "release_name": "Nombre",
                "release_artist_name": "Nombre del Artista del Lanzamiento",
                "release_date": "Fecha de Lanzamiento",
                "exclusive_date": "Fecha Exclusiva"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor, <1>actualiza</1> tu plan de suscripción para aprovechar esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para aprovechar esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        }
    },
    "add": {
        "title": "Hechos de Marketing",
        "form": {
            "label": {
                "release": "Lanzamiento",
                "djTastemaker": "Comentarios de DJ / TasteMaker:",
                "radioSupport": "Soporte de Radio",
                "marketingPR": "Marketing / Pr",
                "labelReach": "Alcance de sellos y artistas:"
            },
            "help_text": {
                "release": "Selecciona un lanzamiento para el cual deseas enviar una solicitud de función. Solo puedes ver y seleccionar lanzamientos que tengan una fecha de lanzamiento general 22 o más días por adelantado. Si estás apuntando a una fecha de lanzamiento exclusiva, asegúrate de enviar este formulario al menos 22 días antes de una (primera) fecha de lanzamiento exclusiva.",
                "djTastemaker": "Inserta 10 comentarios de DJ / Radio / Revista en el formato 'Nombre - Comentario' (Inserta cada comentario en una línea). Las presentaciones que contengan 'descargando para' no serán promovidas ni enviadas a tiendas en línea.",
                "radioSupport": "¿Tu canción o lanzamiento está siendo presentado en algunas estaciones de radio? Si es así, nombra la estación e inserta el enlace correspondiente a su página donde sea visible que están promoviendo o reproduciendo tus canciones.",
                "marketingPR": "(Entrevistas, blogs, reseñas, artículos de revistas) - Por favor, enumera todas las actividades de prensa y marketing comprometidas para este lanzamiento. No es obligatorio pero es esencialmente importante para destacar de la competencia.",
                "labelReach": "La cantidad combinada (de sellos y artistas) de seguidores en Facebook, Instagram, SoundCloud y YouTube. <strong>Por favor, pon cada plataforma y número de seguidores en una nueva fila</strong>."
            },
            "button": {
                "submit": "Enviar"
            },
            "message": {
                "releaseRequired": "Se requiere un lanzamiento existente",
                "featureRequestAlreadyExists": "Ya se ha realizado una solicitud de función para este lanzamiento"
            }
        },
        "message": {
            "success": "¡La solicitud de función ha sido añadida!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e intenta de nuevo."
        },
        "modal": {
            "confirm": {
                "header": "Nueva solicitud de función",
                "body": "Esta solicitud de función debe enviarse al menos 21 días antes de la primera fecha (exclusiva o general, lo que ocurra primero). Desafortunadamente, las presentaciones tardías no pueden ser consideradas. ¿Deseas enviar tu solicitud de función?"
            }
        }
    }
};

export default featureES;